import { ActionReducerMap } from '@ngrx/store';
import { userReducer } from './user.reducer';
import { eventsReducer } from './events.reducer';
import { SharedState } from '../models';
import { resourcesReducer } from './resources.reducer';

import { filterReducer, floorplanFilterReducer } from './filter.reducer';
import { floorplanSchedulesReducer, quickSchedulesReducer, schedulesReducer } from './schedules.reducer';
import { timelineReducer } from './timeline.reducer';
import { operationsReducer } from './operations.reducer';
import { areasReducer } from './areas.reducer';
import { favouritesReducer } from './favourites.reducer';
import { currentUserReducer } from './current-user.reducer';
import { userSettingsReducer } from './user-settings.reducer';
import { filterAttendeesReducer } from './filter-attendees.reducer';
import { controllableObjectsReducer } from './controllable-objects.reducer';
import { myEventsReducer } from './my-events.reducer';

export const sharedReducers: ActionReducerMap<SharedState> = {
  user: userReducer,
  events: eventsReducer,
  resources: resourcesReducer,
  filter: filterReducer,
  floorplanFilter: floorplanFilterReducer,
  schedules: schedulesReducer,
  quickSchedules: quickSchedulesReducer,
  floorPlanSchedules: floorplanSchedulesReducer,
  timelineSettings: timelineReducer,
  operations: operationsReducer,
  areas: areasReducer,
  favourites: favouritesReducer,
  currentUser: currentUserReducer,
  userSettings: userSettingsReducer,
  filterAttendees: filterAttendeesReducer,
  controllableObjects: controllableObjectsReducer,
  myEvents: myEventsReducer,
};
